
import 'tailwindcss/tailwind.css'
import { defineComponent } from 'vue'
import { currentPageState } from './refs'

export default defineComponent({
    name: 'App',
    setup() {
        return {
            currentPageState
        }
    }
})

